import { cloneDeep } from 'lodash';

import { BlockTypeModel } from '../../../Common/PageBuilder/models/block-type.model';
import { TextFieldModel, TextFieldStyle } from '../../../Common/PageBuilder/models/text-field.model';
import { TextFieldComponent } from '../../../Common/PageBuilder/components/FormFields/TextField/text-field.component';
import { DateDisplayElementModel } from '../../../Common/PageBuilder/models/date-display-element.model';
import { CuratedMentionListDisplayElementModel } from './curated-mention-list-display-element.model';
import { DynamicMentionListDisplayElementModel } from './dynamic-mention-list-display-element.model';
import { DynamicMentionListBlockComponent } from '../components/DynamicMentionListBlock/dynamic-mention-list-block.component';
import { BriefingBlockTypeEnum, isMentionBlockTypes } from '../enums/briefing-block-type.enum';
import { NumberFieldComponent } from '../../../Common/PageBuilder/components/FormFields/NumberField/number-field.component';
import { NumberFieldModel } from '../../../Common/PageBuilder/models/number-field.model';
import { MonitoringSourcePickerFieldModel } from '../../Shared/models/monitoring-source-picker-field.model';
import { MonitoringSeriesTypeEnum } from '../../Shared/enums/monitoring-series-type.enum';
import { DropdownOptionModel } from '../../../Common/Forms/models/dropdown-option.model';
import { CuratedMentionListBlockComponent } from '../components/CuratedMentionListBlock/curated-mention-list-block.component';
import { BriefingDateFieldComponent } from '../components/BriefingDateField/briefing-date-field.component';
import { BriefingDateFieldModel } from './briefing-date-field.model';
import { CuratedFiltersFieldModel } from './curated-filters.field.model';
import { CuratedFiltersFieldComponent } from '../components/CuratedFiltersField/curated-filters-field.component';
import { BriefingDateStyleFieldModel } from './briefing-date-style-field.model';
import { BriefingDateStyleFieldComponent } from '../../Shared/components/BriefingDateStyleField/briefing-date-style-field.component';
import { CheckboxFieldModel } from '../../../Common/PageBuilder/models/checkbox-field.model';
import { CheckboxFieldComponent } from '../../../Common/PageBuilder/components/FormFields/CheckboxField/checkbox-field.component';
import { CheckboxOptionModel } from '../../../Common/Forms/models/checkbox-option.model';
import { TextStyleFieldModel } from '../../../Common/PageBuilder/models/text-style-field.model';
import { BriefingTextStyleFieldComponent } from '../../Shared/components/BriefingTextStyleField/briefing-text-style-field.component';
import { BriefingTitleStyleFieldComponent } from '../../Shared/components/BriefingTitleStyleField/briefing-title-style-field.component';
import { MentionCustomizationFieldModel } from '../../Shared/models/mention-customization-field.model';
import { MentionSearchService } from '../../Core/services/mention-search.service';
import { monitoringFiltersEnum } from '../../Shared/enums/monitoring-filters.enum';
import { MentionCustomizationFieldComponent } from '../../Shared/components/MentionCustomizationField/mention-customization-field.component';
import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';
import { TextStyleDefaultsModel } from '../../../Common/PageBuilder/models/text-style-defaults.model';
import { TableOfContentDisplayElementModel } from './table-of-content-display-element.model';
import { TableOfContentSettingsComponent } from '../components/TableOfContentSettings/table-of-content-settings.component';
import { TableOfContentSettingsFieldModel } from './table-of-content-field.model';
import { PanelFieldModel } from '../../../Common/PageBuilder/models/panel-field.model';
import { PanelFieldComponent } from '../../../Common/PageBuilder/components/FormFields/PanelField/panel-field.component';
import { TableOfContentBlockComponent } from '../components/TableOfContentBlock/table-of-content-block.component';
import { TableOfContentStyleFieldComponent } from '../components/TableOfContentStyleField/table-of-content-style-field.component';
import { RichTextBlockComponent } from '../../../Common/PageBuilder/components/RichTextBlock/rich-text-block.component';
import { alertMentionListBlockType } from '../../Alerts/models/alerts-block-types.model';
import { BriefingTextDisplayElementModel } from './briefing-text-display-element.model';
import { ImageSettingsFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ImageSettingsField/image-settings-field.component';
import { ImageSettingsFieldModel } from '../../../Common/PageBuilder/models/image-settings-field.model';
import { ImageStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ImageStyleField/image-style-field.component';
import { ImageStyleFieldModel } from '../../../Common/PageBuilder/models/image-style-field.model';
import { briefingsStyleDropdownOptions, canvasStyleDropdownOptions } from './briefings-style-dropdown-options.model';
import { BriefingSortByFieldComponent } from '../components/BriefingSortByField/briefing-sort-by-field.component';
import { BriefingSortByFieldModel } from './briefing-sort-by.field.model';
import { CuratedInfoFieldModel } from './briefing-curated-info-field.model';
import { DropdownFieldModel } from '../../../Common/PageBuilder/models/dropdown-field.model';
import { DropdownFieldComponent } from '../../../Common/PageBuilder/components/FormFields/DropdownField/dropdown-field.component';
import {
    MonitoringSourcePickerFieldWithoutFacetComponent
} from '../../Shared/components/MonitoringSourcePickerField/monitoring-source-picker-field-without-facet.component';
import { CuratedAdditionalSettingsField } from '../../Shared/models/curated-additional-settings-field.model';
import { CuratedAdditionalSettingsFieldComponent
} from '@Monitor/Briefings/components/CuratedAdditionalSettingsField/curated-additional-settings-field.component';
import { AutomaticAdditionalSettingsField } from '@Monitor/Briefings/models/automatic-additional-settings-field.model';
import { AutomaticAdditionalSettingsFieldComponent } from '../components/AutomaticAdditionalSettingsField/automatic-additional-settings-field.component';
import { LayoutStyleField } from '../../../Common/PageBuilder/models/layout-style-field.model';
import { LayoutStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/LayoutStyleField/layout-style-field.component';
import { LayoutDisplayElement } from '../../../Common/PageBuilder/models/layout-display-element.model';
import { LayoutBlockComponent } from '../../../Common/PageBuilder/components/LayoutBlock/layout-block.component';
import { LayoutBlockType, layoutBlockTypes } from '../../../Common/PageBuilder/models/layout-block-type.model';
import { BlockModel, LayoutBlockTypesEnum } from '../../../Common/PageBuilder/models/block.model';
import { AnalysisFieldComponent } from '../components/AnalysisField/analysis-field.component';
import { AnalysisField } from '@Monitor/Shared/models/analysis-field.model';
import { AnalysisDisplayElementModel } from './briefing-analysis-display-element.model';
import {
    AnalysisBlockMonitoringSourcePickerFieldComponent
} from '@Monitor/Shared/components/MonitoringSourcePickerField/analysis-block-monitoring-source-picker-field.component';
import {
    MultiContentLibraryPanelFieldComponent
} from '../../../Common/PageBuilder/components/FormFields/MultiContentLibraryPanelField/multi-content-library-panel.component';
import { MultiContentLibraryFieldModel } from '../../../Common/PageBuilder/models/multi-content-library-field-model';

import { DividerStyleFieldModel } from '../../../Common/PageBuilder/models/divider-style-field.model';
import { DividerStyleDefaultsModel } from '../../../Common/PageBuilder/models/divider-style-defaults.model';
import { PaddingModel } from '../../../Common/PageBuilder/models/padding.model';
import { DividerStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/DividerField/divider-style-field.component';
import { DividerDisplayElementModel } from '../../../Common/PageBuilder/models/divider-display-element.model';
import { LinkDisplayElementModel } from '../../../Common/PageBuilder/models/link-display-element.model';
import { LinksListFieldModel } from '../../../Common/PageBuilder/models/links-list-field.model';
import { LinksListFieldComponent } from '../../../Common/PageBuilder/components/FormFields/LinksListField/links-list-field.component';
import { LinksStyleFieldModel } from '../../../Common/PageBuilder/models/links-style-field.model';
import { LinksStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/LinksStyleField/links-style-field.component';
import { BriefingStyleStateEnum } from '../../../Common/MonitorShared/enum/briefing-style-state.enum';
import { ChartFieldModel } from '../../../Common/PageBuilder/models/chart-field.model';
import { ChartFieldComponent } from '../../../Common/PageBuilder/components/FormFields/ChartField/chart-field.component';
import { BriefingChartDisplayElementModel } from '../../../Common/PageBuilder/models/briefing-chart-display-element.model';
import { BriefingChartBlockComponent } from '../components/BriefingChartBlock/briefing-chart-block.component';
import { BriefingChartDimensionsFieldModel } from '@Common/PageBuilder/models/briefing-chart-dimensions-field.model';
import {
    BriefingChartDimensionsFieldComponent
} from '@Common/PageBuilder/components/FormFields/BriefingChartDimensionsField/briefing-chart-dimensions-field.component';
import { briefingHeadingLevelOptions } from './briefing-heading-level.model';
import { BriefingTitleDisplayElementModel } from './briefing-title-display-element.model';
import { MonitoringTitleFieldModel } from '../../Shared/models/monitoring-title-field.model';
import { BriefingHeadingLevelEnum } from '../enums/briefing-heading-level.enum';
import { CuratedSortByFieldComponent } from '../components/CuratedSortByField/curated-sort-by-field.component';
import {
    BriefingChartSettingsFieldComponent
} from '../../../Common/PageBuilder/components/FormFields/ImageSettingsField/briefing-chart-settings-field.component';
import { ImageEffectsFieldModel } from '@Common/PageBuilder/models/image-effects-field.model';
import { ImageEffectsFieldComponent } from '@Common/PageBuilder/components/FormFields/ImageEffectsField/image-effects-field.component';
import { BlockDisplayTypeEnum } from '@Common/PageBuilder/enums/block-display-type.enum';
import { BriefingImageDisplayElementModel } from '@Common/PageBuilder/models/briefing-image-display-element.model';
import { BriefingImageBlockComponent } from '../components/BriefingImageBlock/briefing-image-block.component';
import { CuratorBlockType } from '../../../Common/PageBuilder/models/curator-block-type.model';
import { CuratorDisplayElement } from '../../../Common/PageBuilder/models/curator-display-element.model';
import { CuratorBlockComponent } from '../../../Common/PageBuilder/components/CuratorBlock/curator-block.component';
import { CuratorStyleFieldComponent } from '../../../Common/PageBuilder/components/FormFields/CuratorStyleField/curator-style-field.component';
import { CuratorStyleFieldModel } from '../../../Common/PageBuilder/models/curator-style-field.model';
import { RadioButtonsFieldModel } from '../../../Common/PageBuilder/models/radio-buttons-field.model';
import { RadioButtonsFieldComponent } from '../../../Common/PageBuilder/components/FormFields/RadioButtonsField/radio-buttons-field.component';
import { RadioButtonOptionModel } from '../../../Common/Forms/models/radio-button-option.model';
import { CuratorAnalysisButtonFieldModel } from '../../../Common/PageBuilder/models/curator-analysis-button-field.model';
import { CuratorAnalysisButtonFieldComponent } from '../components/CuratorAnalysisButtonField/curator-analysis-button-field.component';
import { DisplayElementModel } from '../../../Common/PageBuilder/models/display-element.model';
import { AiAnalysisTypes } from '../../../Common/Mentions/enums/ai-analysis-types.enum';
import { BooleanRadioFieldModel } from '../../../Common/PageBuilder/models/boolean-radio-field.model';
import { BooleanRadioFieldComponent } from '../../../Common/PageBuilder/components/FormFields/BooleanRadioField/boolean-radio-field.component';
import { promptLanguageOptions } from '../../../Common/Forms/data/prompt-language-options';
import { BriefingDeliveryMethodEnum } from '../enums/briefing-delivery-method.enum';
import { BriefingsService } from '../services/briefings.service';
import { TextStyleFieldComponent } from '../../../Common/PageBuilder/components/TextStyleField/text-style-field.component';
import { StyleStateEnum } from '../../../Common/PageBuilder/enums/style-state.enum';
import { CuratedInfoSectionComponent } from '../components/CuratedInfoSection/curated-info-section.component';
import { ResizeDirectionEnum } from '../../../Common/Forms/components/TextareaInput/textarea-input.component';

export const dateBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.DATE,
    'Briefings.blockType.date',
    'fa-duotone fa-regular fa-duotone fa-calendar-range',
    null,
    DateDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.blockType.date',
            '',
            [
                new BriefingDateFieldModel(
                    BriefingDateFieldComponent,
                    'date',
                    'Briefings.formField.dateLabel',
                    null
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.dateStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new BriefingDateStyleFieldModel(
                    BriefingDateStyleFieldComponent,
                    'styles',
                    'DateStyleField.dateLine',
                    '',
                    (x: BriefingDateStyleFieldComponent) => {
                        const deliveryMethod = (x.briefingsService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return canvasStyleDropdownOptions;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ]
        )
    ]
);

export const curatedMentionListBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.CURATED_MENTION_LIST,
    'Briefings.blockType.mentionList.curated',
    'fa-regular fa-duotone fa-list-ul',
    null,
    CuratedMentionListDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.blockType.mentionList.curated',
            '',
            [
                new TextFieldModel(
                    TextFieldComponent,
                    'title',
                    'Briefings.mentionList.form.sectionHeading',
                    null,
                    false,
                    256
                ),
                new CuratedFiltersFieldModel(
                    CuratedFiltersFieldComponent,
                    'searchCriteria',
                    'Briefings.mentionList.form.rules',
                    null,
                    'Briefings.mentionList.form.rules.tooltip',
                    'Briefings.mentionList.form.rules.emptyMessage',
                    'Briefings.mentionList.form.rules.overflowMessage'
                ),
                new BriefingSortByFieldModel(
                    CuratedSortByFieldComponent,
                    'sortBy',
                    'Briefings.mentionList.form.sortBy',
                ),
                new NumberFieldModel(
                    NumberFieldComponent,
                    'mentionPreviewCount',
                    'Briefings.mentionList.form.previewMentionCount',
                    null,
                    'Briefings.mentionList.form.previewMentionCount.placeholder',
                    1000,
                    null,
                    'Briefings.mentionList.form.previewMentionCount.tooltip',
                    'left',
                    (block: BlockModel) => {
                        return block ? block?.displayElement?.displayType === BlockDisplayTypeEnum.ONLINE : false;
                    }
                ),
                // HACK: just need an info section
                new CuratedInfoFieldModel(
                    CuratedInfoSectionComponent,
                    ''
                ),
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.blockType.additionalSettings',
            '',
            [ new CuratedAdditionalSettingsField(CuratedAdditionalSettingsFieldComponent) ],
            (hasAutoGenAccess: boolean) => hasAutoGenAccess
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.mentionStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new MentionCustomizationFieldModel(
                    MentionCustomizationFieldComponent,
                    'styles',
                    'MentionStyleField.heading',
                    '',
                    undefined,
                    (x: MentionCustomizationFieldComponent) => {
                        const deliveryMethod = (x.briefingsService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            const options: DropdownOptionModel[] = cloneDeep(canvasStyleDropdownOptions);
                            const canvasOne: DropdownOptionModel = options.find(({value}) => value === BriefingStyleStateEnum.CANVAS_1);
                            if (canvasOne) {
                                canvasOne.label = 'Briefings.formField.styles.defaultAgilityStyleGrid';
                            }
                            return options;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ]
        )
    ],
    CuratedMentionListBlockComponent
);
export const dynamicMentionListBlockType: BlockTypeModel = new BlockTypeModel(
    BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST,
    'Briefings.blockType.mentionList.dynamic',
    'fa-regular fa-duotone fa-list-ul',
    null,
    DynamicMentionListDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            'dynamicMentionListPanel',
            'Briefings.blockType.mentionList.dynamic',
            '',
            [
                new BooleanRadioFieldModel(
                    BooleanRadioFieldComponent,
                    'automaticallyGenerated',
                    'PageBuilder.automaticallyGeneratedContent.ai',
                    'PageBuilder.automaticallyGeneratedContent.manual',
                    (displayElement) => {
                        return displayElement?.canAutomaticallyGenerated;
                    }
                ),
                new TextFieldModel(
                    TextFieldComponent,
                    'title',
                    'Briefings.mentionList.form.sectionHeading',
                    null,
                    false,
                    256,
                    '',
                    false,
                    null,
                    null,
                    'PageBuilder.automaticallyGeneratedContent.placeholder'
                ),
                new MonitoringSourcePickerFieldModel(
                    MonitoringSourcePickerFieldWithoutFacetComponent,
                    'backendDataSource',
                    '',
                    '',
                    {
                        dataSourceLabel: 'Monitoring.sourcePickerField.coverageSource',
                        dateRangeLabel: 'Monitoring.sourcePickerField.dateRange',
                        mentionCountLocalizationLabel: 'Monitoring.sourcePickerField.briefingsResultFeedbackMessage',
                        maxNumberOfMentions: 1000,
                        dataSourceNullErrorMessage: 'Monitoring.sourcePickerField.dataSourceRequiredMessage',
                        dataSourceOptions: [
                            new DropdownOptionModel('Briefings.allSavedCoverage', MonitoringSeriesTypeEnum.allSavedCoverage),
                            new DropdownOptionModel('Reports.series.type.topic', MonitoringSeriesTypeEnum.topic),
                            new DropdownOptionModel('Reports.series.type.folder', MonitoringSeriesTypeEnum.folder),
                            new DropdownOptionModel('Reports.series.type.tag', MonitoringSeriesTypeEnum.tag),
                            new DropdownOptionModel('Reports.series.type.tagGroup', MonitoringSeriesTypeEnum.tagGroup),
                            new DropdownOptionModel('Reports.series.type.subscription', MonitoringSeriesTypeEnum.subscription),
                            new DropdownOptionModel('Monitoring.source.type.sourceGroup', MonitoringSeriesTypeEnum.sourceGroup),
                            new DropdownOptionModel('Reports.series.type.socialTopic', MonitoringSeriesTypeEnum.socialTopic),
                            new DropdownOptionModel('Reports.series.type.theme', MonitoringSeriesTypeEnum.theme),
                            new DropdownOptionModel('Reports.series.type.aiAgent', MonitoringSeriesTypeEnum.aiAgent)
                        ],
                        showResultsFeedback: false,
                        showLoadingFeedback: false,
                        showTooManyMentionsError: false,
                        showFilters: true,
                        orderedAccountFilters: MentionSearchService.defaultOrderedAccountFilters.concat(monitoringFiltersEnum.regions),
                        orderedMercuryFilters: MentionSearchService.defaultOrderedMercuryFilters.concat(monitoringFiltersEnum.regions)
                    }
                ),
                new NumberFieldModel(
                    NumberFieldComponent,
                    'pageSize',
                    'Briefings.dynamicMentionsList.form.numberOfMentions',
                    null,
                    'Briefings.dynamicMentionsList.form.selectPageSize.placeholder',
                    1000,
                    1,
                    'Briefings.dynamicMentionsList.form.numberOfMentionsTooltip',
                    'left'
                ),
                new BriefingSortByFieldModel(
                    BriefingSortByFieldComponent,
                    'backendDataSource.filterSearchCriteria',
                    'Briefings.mentionList.form.sortBy',
                    true
                ),
                new NumberFieldModel(
                    NumberFieldComponent,
                    'mentionPreviewCount',
                    'Briefings.mentionList.form.previewMentionCount',
                    null,
                    'Briefings.mentionList.form.previewMentionCount.placeholder',
                    100,
                    null,
                    'Briefings.mentionList.form.previewMentionCount',
                    'left',
                    (block: BlockModel) => {
                        return block ? block?.displayElement?.displayType === BlockDisplayTypeEnum.ONLINE : false;
                    }
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.blockType.additionalSettings',
            '',
            [
                new AutomaticAdditionalSettingsField(
                    AutomaticAdditionalSettingsFieldComponent
                ),
            ],
            (hasAutoGenAccess: boolean) => hasAutoGenAccess
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.mentionStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new MentionCustomizationFieldModel(
                    MentionCustomizationFieldComponent,
                    'styles',
                    'MentionStyleField.heading',
                    '',
                    undefined,
                    (x: MentionCustomizationFieldComponent) => {
                        const deliveryMethod = (x.briefingsService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            const options: DropdownOptionModel[] = cloneDeep(canvasStyleDropdownOptions);
                            const canvasOne: DropdownOptionModel = options.find(({value}) => value === BriefingStyleStateEnum.CANVAS_1);
                            if (canvasOne) {
                                canvasOne.label = 'Briefings.formField.styles.defaultAgilityStyleGrid';
                            }
                            return options;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ]
        )
    ],
    DynamicMentionListBlockComponent
);

export const titleBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.TITLE,
    'PageBuilder.blockType.title',
    'agpr-i-headline',
    null,
    BriefingTitleDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.title',
            '',
            [
                new BooleanRadioFieldModel(
                    BooleanRadioFieldComponent,
                    'automaticallyGenerated',
                    'PageBuilder.automaticallyGeneratedContent.ai',
                    'PageBuilder.automaticallyGeneratedContent.manual',
                    (displayElement) => {
                        return displayElement?.canAutomaticallyGenerated;
                    }
                ),
                new TextFieldModel(
                    TextFieldComponent,
                    'text',
                    'PageBuilder.formField.titleLabel',
                    null,
                    false,
                    128,
                    'Briefing.title.settings.helperText',
                    null,
                    null,
                    null,
                    'PageBuilder.automaticallyGeneratedContent.placeholder'
                ),
                new DropdownFieldModel(
                    DropdownFieldComponent,
                    'headingLevel',
                    'Briefings.formField.title.headlingLevel',
                    null,
                    [
                        ...briefingHeadingLevelOptions
                    ]
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.titleStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new MonitoringTitleFieldModel(
                    'styles',
                    false,
                    new TextStyleDefaultsModel(
                        '24px',
                        '#5e6473',
                        true,
                    ),
                    `Briefings.title.headingLevel.style.${BriefingHeadingLevelEnum.HEADING_1}`,
                    false,
                    true,
                    true,
                    StyleTypesApiEnum.TITLE,
                    BriefingTitleStyleFieldComponent,
                    null,
                    true,
                    true,
                    briefingsStyleDropdownOptions,
                    (x: BriefingTitleStyleFieldComponent) => {
                        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return canvasStyleDropdownOptions;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ],
        )
    ]
);

export const briefingTextBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.TEXT,
    'PageBuilder.blockType.text',
    'fa-solid fa-align-left',
    null,
    BriefingTextDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.textStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new TextStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '14px',
                        '#292929',
                        false
                    ),
                    'Briefing.textStyle.text.label',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.TEXT,
                    BriefingTextStyleFieldComponent,
                    null,
                    true,
                    true,
                    briefingsStyleDropdownOptions,
                    (x: TextStyleFieldComponent) => {
                        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return canvasStyleDropdownOptions;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ]
        )
    ],
    RichTextBlockComponent
);

export const defaultAnalysisSourcePickerField: MonitoringSourcePickerFieldModel = new MonitoringSourcePickerFieldModel(
    AnalysisBlockMonitoringSourcePickerFieldComponent,
    'backendDataSource',
    '',
    '',
    {
        dataSourceLabel: 'Monitoring.sourcePickerField.coverageSource',
        maxNumberOfMentions: 10000,
        warningNumberOfMentions: 400,
        dateRangeLabel: 'Monitoring.sourcePickerField.dateRange',
        mentionCountLocalizationLabel: 'Monitoring.sourcePickerField.analysisResultFeedbackMessage',
        dataSourceNullErrorMessage: 'Monitoring.sourcePickerField.dataSourceRequiredMessage',
        mentionCountLimitExceededLocalizationTitle: 'Monitoring.bulkActionDialog.sourcePickerField.collectionMayBeReduced',
        mentionCountLimitExceededLocalizationLabel: 'Monitoring.bulkActionDialog.sourcePickerField.pleaseRefineSource',
        showTooManyMentionsError: true,
        showResultsFeedbackAnalysis: true,
        showResultsFeedback: false,
        showLoadingFeedback: true,
        dataSourceOptions: [
            new DropdownOptionModel(`Briefings.coverageSource.${MonitoringSeriesTypeEnum.coverageInSection}`, MonitoringSeriesTypeEnum.coverageInSection),
            // eslint-disable-next-line max-len
            new DropdownOptionModel(`Briefings.coverageSource.${MonitoringSeriesTypeEnum.allCuratedCoverageInBrief}`, MonitoringSeriesTypeEnum.allCuratedCoverageInBrief),
            new DropdownOptionModel('Briefings.allSavedCoverage', MonitoringSeriesTypeEnum.allSavedCoverage),
            new DropdownOptionModel('Reports.series.type.topic', MonitoringSeriesTypeEnum.topic),
            new DropdownOptionModel('Reports.series.type.folder', MonitoringSeriesTypeEnum.folder),
            new DropdownOptionModel('Reports.series.type.tag', MonitoringSeriesTypeEnum.tag),
            new DropdownOptionModel('Reports.series.type.tagGroup', MonitoringSeriesTypeEnum.tagGroup),
            new DropdownOptionModel('Reports.series.type.subscription', MonitoringSeriesTypeEnum.subscription),
            new DropdownOptionModel('Monitoring.source.type.sourceGroup', MonitoringSeriesTypeEnum.sourceGroup),
            new DropdownOptionModel('Reports.series.type.socialTopic', MonitoringSeriesTypeEnum.socialTopic),
            new DropdownOptionModel('Reports.series.type.theme', MonitoringSeriesTypeEnum.theme),
            new DropdownOptionModel('Reports.series.type.aiAgent', MonitoringSeriesTypeEnum.aiAgent),
        ],
        showFilters: true,
        orderedAccountFilters: MentionSearchService.defaultOrderedAccountFilters.concat(monitoringFiltersEnum.regions),
        orderedMercuryFilters: MentionSearchService.defaultOrderedMercuryFilters.concat(monitoringFiltersEnum.regions),
    }
);

export const briefingAnalysisBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.ANALYSIS,
    'PageBuilder.blockType.analysis',
    'fa-kit-duotone fa-agpr-insights',
    null,
    AnalysisDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.analysis.header',
            '',
            [
                new BooleanRadioFieldModel(
                    BooleanRadioFieldComponent,
                    'automaticallyGenerated',
                    'PageBuilder.automaticallyGeneratedContent.ai',
                    'PageBuilder.automaticallyGeneratedContent.manual',
                    (displayElement) => {
                        return displayElement?.canAutomaticallyGenerated;
                    }
                ),
                defaultAnalysisSourcePickerField,
                new AnalysisField(
                    AnalysisFieldComponent,
                    'Briefings.blockType.autoGeninsights.label',
                    'analysisField',
                ),
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefing.styles.analysisStylesSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new TextStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '14px',
                        '#292929',
                        false
                    ),
                    'Briefing.textStyle.analysis.label',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.ANALYSIS,
                    BriefingTextStyleFieldComponent,
                    null,
                    true,
                    true,
                    briefingsStyleDropdownOptions,
                    (x: BriefingTextStyleFieldComponent) => {
                        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return canvasStyleDropdownOptions;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ]
        )
    ],
    RichTextBlockComponent,
    null,
    'Briefing.blocks.reachLimit.analysis'
);

export const briefingChartBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.CHART,
    'PageBuilder.blockType.chart',
    'fa-pie-chart fa-duotone fa-regular',
    null,
    BriefingChartDisplayElementModel,
    [
        new ChartFieldModel(
            ChartFieldComponent,
            'chart',
            [
                new PanelFieldModel(
                    PanelFieldComponent,
                    '',
                    'PageBuilder.blockType.chart.settings',
                    '',
                    [
                        new BriefingChartDimensionsFieldModel(
                            BriefingChartDimensionsFieldComponent,
                            'chart'
                        ),
                        new ImageSettingsFieldModel(
                            BriefingChartSettingsFieldComponent,
                            'settings',
                            '',
                            '',
                            true,
                            true,
                            false,
                            false
                        ),
                        new CheckboxFieldModel(
                            CheckboxFieldComponent,
                            'isBoundToGlobalStyles',
                            '',
                            '',
                            new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                            true
                        ),
                        new ImageStyleFieldModel(
                            'styles',
                            true,
                            new TextStyleDefaultsModel(
                                '24px',
                                '#5e6473',
                                true
                            ),
                            'Briefing.chartStyle.chart.label',
                            true,
                            true,
                            true,
                            StyleTypesApiEnum.CHART,
                            ImageStyleFieldComponent,
                            '',
                            briefingsStyleDropdownOptions,
                            (x: ImageStyleFieldComponent) => {
                                const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                                if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                                    return canvasStyleDropdownOptions;
                                } else {
                                    return briefingsStyleDropdownOptions;
                                }
                            },
                            true
                        )
                    ]
                )
            ]
        )
    ],
    BriefingChartBlockComponent,
    false,
    null,
    true,
    false
);

export const briefingLinkBlockInnerStyleField = new LinksStyleFieldModel(
    'styles',
    LinksStyleFieldComponent,
    'PageBuilder.formField.linkLabel',
    null,
    [
        { label: 'Briefings.formField.styles.defaultAgilityStyleOne', value: BriefingStyleStateEnum.BRIEFING_1 },
        { label: 'Briefings.formField.styles.custom', value: BriefingStyleStateEnum.CUSTOM }
    ],
    StyleTypesApiEnum.LINK,
    (x: LinksStyleFieldComponent) => {
        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
            return canvasStyleDropdownOptions;
        } else {
            return [
                { label: 'Briefings.formField.styles.defaultAgilityStyleOne', value: BriefingStyleStateEnum.BRIEFING_1 },
                { label: 'Briefings.formField.styles.custom', value: BriefingStyleStateEnum.CUSTOM }
            ];
        }
    }
);

export const briefingLinkBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.LINK,
    'PageBuilder.blockType.links',
    'fa-regular fa-duotone fa-link',
    null,
    LinkDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.links',
            '',
            [
                new LinksListFieldModel(
                    'links',
                    [],
                    LinksListFieldComponent,
                    'PageBuilder.formField.linkLabel',
                    'PageBuilder.formField.linkDescription',
                ),
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.linksStyleSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                briefingLinkBlockInnerStyleField
            ],
        )
    ]
);

export const briefingImageBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.IMAGE,
    'PageBuilder.blockType.image',
    'fa-regular fa-duotone fa-image',
    null,
    BriefingImageDisplayElementModel,
    [
        new MultiContentLibraryFieldModel(
            MultiContentLibraryPanelFieldComponent,
            'images',
            'Briefings.fields.image.imageUpload',
            {
                description: 'PageBuilder.formField.uploadDescription',
                maxFiles: 4,
                placeholder: 'Mention.workbench.image.placeholder',
            }
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.fields.image.imageEffects',
            '',
            [
                new ImageEffectsFieldModel(
                    ImageEffectsFieldComponent,
                    'imageEffects',
                    'PageBuilder.formField.uploadLabel',
                    'PageBuilder.formField.uploadDescription',
                ),
            ],
            null,
            (block: BlockModel) => {
                return block ? block?.displayElement?.displayType === BlockDisplayTypeEnum.ONLINE : false;
            },
            0
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.fields.image.imageSettings',
            '',
            [
                new ImageSettingsFieldModel(
                    ImageSettingsFieldComponent,
                    'imageProperties',
                    'PageBuilder.formField.uploadLabel',
                    'PageBuilder.formField.uploadDescription',
                    true, // enableTooltip
                    false // enableAltText
                ),
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new ImageStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '24px',
                        '#5e6473',
                        true
                    ),
                    'Briefing.imageTextStyle.image.label',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.IMAGE,
                    ImageStyleFieldComponent,
                    '',
                    briefingsStyleDropdownOptions,
                    (x: ImageStyleFieldComponent) => {
                        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return canvasStyleDropdownOptions;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    },
                    false
                )
            ]
        )
    ],
    BriefingImageBlockComponent
);

export const briefingDividerBlockInnerStyleField = new DividerStyleFieldModel(
    'styles',
    true,
    new DividerStyleDefaultsModel(
        2,
        '#C7C7C7',
        '#FFFFFF',
        new PaddingModel(0, true, 20, 0, 20 , 0)
    ),
    'PageBuilder.formField.dividerLabel',
    true,
    StyleTypesApiEnum.DIVIDER,
    DividerStyleFieldComponent,
    undefined,
    briefingsStyleDropdownOptions,
    (x: DividerStyleFieldComponent) => {
        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
            return canvasStyleDropdownOptions;
        } else {
            return briefingsStyleDropdownOptions;
        }
    }
);

export const briefingDividerBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.DIVIDER,
    'PageBuilder.blockType.divider',
    'fa-kit-duotone fa-agpr-divider',
    null,
    DividerDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.divider',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('PageBuilder.formField.updateAllBlocksOfType', ''),
                    true
                ),
                briefingDividerBlockInnerStyleField
            ]
        )
    ]
);

export const tableOfContentBlockType = new BlockTypeModel(
    BriefingBlockTypeEnum.TABLE_OF_CONTENT,
    'Briefings.blockType.tableOfContent',
    'fa-regular fa-duotone fa-list-ul',
    null,
    TableOfContentDisplayElementModel,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.fields.tableOfContent.tableOfContentSettings',
            '',
            [
                new TableOfContentSettingsFieldModel(
                    TableOfContentSettingsComponent,
                    'settings',
                    '',
                    ''
                )
            ]
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'Briefings.fields.tableOfContent.tableOfContentStyleSettings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new TextStyleFieldModel(
                    'styles',
                    true,
                    new TextStyleDefaultsModel(
                        '14px',
                        '#292929',
                        false
                    ),
                    'Briefings.blockType.tableOfContent',
                    true,
                    true,
                    true,
                    StyleTypesApiEnum.TABLE_OF_CONTENT,
                    TableOfContentStyleFieldComponent,
                    undefined,
                    true,
                    true,
                    briefingsStyleDropdownOptions,
                    (x: TextStyleFieldComponent) => {
                        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return canvasStyleDropdownOptions;
                        } else {
                            return briefingsStyleDropdownOptions;
                        }
                    }
                )
            ]
        )
    ],
    TableOfContentBlockComponent
);


export const briefingOneColumnLayoutBlockInnerStyleField = new LayoutStyleField(
    LayoutStyleFieldComponent,
    1,
    (x: LayoutStyleFieldComponent) => {
        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
            return [
                { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
            ];
        } else {
            return [
                { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
            ];
        }
    }
);
export const briefingOneColumnLayoutBlockType = new LayoutBlockType(
    BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT,
    'PageBuilder.blockType.layout.oneColumn',
    'fa-regular fa-duotone fa-objects-column',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.oneColumnLayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                briefingOneColumnLayoutBlockInnerStyleField
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        return blockType
            ? (layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) || blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR)
            : false;
    }
);

export const briefingTwoColumnLayoutBlockInnerStyleField = new LayoutStyleField(
    LayoutStyleFieldComponent,
    2,
    (x: LayoutStyleFieldComponent) => {
        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
            return [
                { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
            ];
        } else {
            return [
                { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
            ];
        }
    }
);
export const briefingTwoColumnLayoutBlockType = new LayoutBlockType(
    BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT,
    'PageBuilder.blockType.layout.twoColumn',
    'fa-regular fa-duotone fa-objects-column',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.twoColumnlayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                briefingTwoColumnLayoutBlockInnerStyleField
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        const isLayoutBlock = blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
        const isMentionBlock = blockType ? isMentionBlockTypes(blockType) : false;
        const isCuratorBlock = blockType ? blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR : false;

        return isLayoutBlock || isMentionBlock || isCuratorBlock;
    }
);

export const briefingThreeColumnLayoutBlockInnerStyleField = new LayoutStyleField(
    LayoutStyleFieldComponent,
    3,
    (x: LayoutStyleFieldComponent) => {
        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
            return [
                { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
            ];
        } else {
            return [
                { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
            ];
        }
    }
);
export const briefingThreeColumnLayoutBlockType = new LayoutBlockType(
    BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT,
    'PageBuilder.blockType.layout.threeColumn',
    'fa-regular fa-duotone fa-objects-column',
    null,
    LayoutDisplayElement,
    [
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.formField.panelHeader.threeColumnlayout',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                briefingThreeColumnLayoutBlockInnerStyleField
            ]
        )
    ],
    LayoutBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        const isLayoutBlock = blockType ? layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum) : false;
        const isMentionBlock = blockType ? isMentionBlockTypes(blockType) : false;
        const isCuratorBlock = blockType ? blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR : false;

        return isLayoutBlock || isMentionBlock || isCuratorBlock;
    }
);


export const defaultCoverageCuratorDatasourceField = new MonitoringSourcePickerFieldModel(
    AnalysisBlockMonitoringSourcePickerFieldComponent,
    'backendDataSource',
    '',
    '',
    {
        dataSourceLabel: 'Monitoring.sourcePickerField.coverageSource',
        dateRangeLabel: 'Monitoring.sourcePickerField.dateRange',
        mentionCountLocalizationLabel: 'Monitoring.sourcePickerField.briefingsResultFeedbackMessage',
        maxNumberOfMentions: 1000,
        warningNumberOfMentions: 400,
        dataSourceNullErrorMessage: 'Monitoring.sourcePickerField.dataSourceRequiredMessage',
        mentionCountLimitExceededLocalizationTitle: 'Monitoring.bulkActionDialog.sourcePickerField.collectionMayBeReduced',
        mentionCountLimitExceededLocalizationLabel: 'Monitoring.bulkActionDialog.sourcePickerField.pleaseRefineSource',
        dataSourceOptions: [
            new DropdownOptionModel('Briefings.allSavedCoverage', MonitoringSeriesTypeEnum.allSavedCoverage),
            new DropdownOptionModel('Reports.series.type.topic', MonitoringSeriesTypeEnum.topic),
            new DropdownOptionModel('Reports.series.type.folder', MonitoringSeriesTypeEnum.folder),
            new DropdownOptionModel('Reports.series.type.tag', MonitoringSeriesTypeEnum.tag),
            new DropdownOptionModel('Reports.series.type.tagGroup', MonitoringSeriesTypeEnum.tagGroup),
            new DropdownOptionModel('Reports.series.type.subscription', MonitoringSeriesTypeEnum.subscription),
            new DropdownOptionModel('Monitoring.source.type.sourceGroup', MonitoringSeriesTypeEnum.sourceGroup),
            new DropdownOptionModel('Reports.series.type.socialTopic', MonitoringSeriesTypeEnum.socialTopic),
            new DropdownOptionModel('Reports.series.type.theme', MonitoringSeriesTypeEnum.theme),
            new DropdownOptionModel('Reports.series.type.aiAgent', MonitoringSeriesTypeEnum.aiAgent)
        ],
        showResultsFeedback: false,
        showResultsFeedbackAnalysis: true,
        showLoadingFeedback: true,
        showTooManyMentionsError: true,
        showFilters: true,
        orderedAccountFilters: MentionSearchService.defaultOrderedAccountFilters.concat(monitoringFiltersEnum.regions),
        orderedMercuryFilters: MentionSearchService.defaultOrderedMercuryFilters.concat(monitoringFiltersEnum.regions)
    }
);

export const briefingCuratorBlockType = new CuratorBlockType(
    BriefingBlockTypeEnum.COVERAGE_CURATOR,
    'PageBuilder.blockType.curator',
    'fa-kit-duotone fa-agpr-ai-coverage',
    null,
    CuratorDisplayElement,
    [
        new RadioButtonsFieldModel(
            RadioButtonsFieldComponent,
            'bulkAnalysisMessage.aiAnalysisType',
            '',
            false,
            [
                new RadioButtonOptionModel(
                    'PageBuilder.blockType.curation.settings.type.topMentions',
                    AiAnalysisTypes.COLLECTION_TOP_MENTIONS,
                    false,
                    'PageBuilder.blockType.curation.settings.type.topMentions.tooltip'
                ),
                new RadioButtonOptionModel(
                    'PageBuilder.blockType.curation.settings.type.keyMessages',
                    AiAnalysisTypes.COLLECTION_KEY_MESSAGES_DEFAULT,
                    false,
                    'PageBuilder.blockType.curation.settings.type.keyMessages.tooltip'
                ),
                new RadioButtonOptionModel(
                    'PageBuilder.blockType.curation.settings.type.custom',
                    AiAnalysisTypes.COLLECTION_CUSTOM,
                    false,
                    'PageBuilder.blockType.curation.settings.type.custom.tooltip'
                )
            ],
            false,
            'coverageCuratorType',
            null,
            null,
            'PageBuilder.blockType.curation.settings.type'
        ),
        new TextFieldModel(
            TextFieldComponent,
            'bulkAnalysisMessage.adHocCustomPrompt',
            'PageBuilder.blockType.curation.settings.CurationInstructions',
            null,
            true,
            255,
            'PageBuilder.blockType.curation.settings.CurationInstructions.placeholder',
            null,
            null,
            null,
            null,
            (displayElement: CuratorDisplayElement) => {
                return displayElement?.bulkAnalysisMessage?.aiAnalysisType === AiAnalysisTypes.COLLECTION_CUSTOM;
            },
            {indent: 30} as TextFieldStyle,
            ResizeDirectionEnum.vertical,
            true,
            true,
            'fa-kit-duotone fa-agpr-ai-generic'
        ),
        defaultCoverageCuratorDatasourceField,
        new TextFieldModel(
            TextFieldComponent,
            'bulkAnalysisMessage.focus',
            'PageBuilder.blockType.curation.settings.analysisFocus',
            null,
            false,
            255,
            'PageBuilder.blockType.curation.settings.analysisFocus.placeholder',
            null,
            'PageBuilder.blockType.curation.settings.analysisFocus.tooltip'
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'bulkAnalysisMessage.selectedLanguageTag',
            'Common.dialog.aiHelper.language',
            null,
            promptLanguageOptions,
            'Common.dialog.aiHelper.languageTooltip',
            null
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'bulkAnalysisMessage.numberKeyMessages',
            'PageBuilder.blockType.curation.settings.numberOfKeyMessages',
            null,
            [
                {label: '1' , value: 1},
                {label: '2' , value: 2},
                {label: '3' , value: 3},
                {label: '4' , value: 4},
                {label: '5' , value: 5}
            ],
            'PageBuilder.blockType.curation.settings.numberOfKeyMessages.tooltip',
            null,
            (displayElement: DisplayElementModel) => {
                const curatorType = (displayElement as CuratorDisplayElement)?.bulkAnalysisMessage.aiAnalysisType;
                return curatorType ===  AiAnalysisTypes.COLLECTION_KEY_MESSAGES_DEFAULT;
            }
        ),
        new CuratorAnalysisButtonFieldModel(
            CuratorAnalysisButtonFieldComponent,
            'generateOnSend'
        ),
        new PanelFieldModel(
            PanelFieldComponent,
            '',
            'PageBuilder.blockType.curator.settings',
            '',
            [
                new CheckboxFieldModel(
                    CheckboxFieldComponent,
                    'isBoundToGlobalStyles',
                    '',
                    '',
                    new CheckboxOptionModel('Briefings.sidebar.updateAllBlocksOfType', ''),
                    true
                ),
                new CuratorStyleFieldModel(
                    CuratorStyleFieldComponent,
                    (x: CuratorStyleFieldComponent) => {
                        const deliveryMethod = (x.abstractPageBuilderService as BriefingsService).getCurrentBriefingDeliveryMethod();
                        if (deliveryMethod === BriefingDeliveryMethodEnum.ONLINE) {
                            return [
                                { label: 'Briefings.formField.styles.defaultAgilityCanvasOne', value: BriefingStyleStateEnum.CANVAS_1 },
                                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
                            ];
                        } else {
                            return [
                                { label: 'PageBuilder.formField.styles.defaultAgilityStyle', value: StyleStateEnum.DEFAULT },
                                { label: 'PageBuilder.formField.styles.custom', value: StyleStateEnum.CUSTOM }
                            ];
                        }
                    }
                )
            ]
        )
    ],
    CuratorBlockComponent,
    false,
    (blockType: BlockTypeModel) => {
        return blockType ? (
            (blockType.key === BriefingBlockTypeEnum.CHART ||
            layoutBlockTypes.includes(blockType.key as LayoutBlockTypesEnum)) ||
            (blockType.key === BriefingBlockTypeEnum.COVERAGE_CURATOR)) : false;
    }
);

export const briefingBlockTypeEnumToBlockTypeMap: Map<BriefingBlockTypeEnum, BlockTypeModel|LayoutBlockType|CuratorBlockType> = new Map(
    [
        [ BriefingBlockTypeEnum.TITLE,                  titleBlockType                     ],
        [ BriefingBlockTypeEnum.TEXT,                   briefingTextBlockType              ],
        [ BriefingBlockTypeEnum.IMAGE,                  briefingImageBlockType             ],
        [ BriefingBlockTypeEnum.DATE,                   dateBlockType                      ],
        [ BriefingBlockTypeEnum.TABLE_OF_CONTENT,       tableOfContentBlockType            ],
        [ BriefingBlockTypeEnum.CURATED_MENTION_LIST,   curatedMentionListBlockType        ],
        [ BriefingBlockTypeEnum.AUTOMATIC_MENTION_LIST, dynamicMentionListBlockType        ],
        [ BriefingBlockTypeEnum.ALERT_MENTIONS,         alertMentionListBlockType          ],
        [ BriefingBlockTypeEnum.ONE_COLUMN_LAYOUT,      briefingOneColumnLayoutBlockType   ],
        [ BriefingBlockTypeEnum.TWO_COLUMN_LAYOUT,      briefingTwoColumnLayoutBlockType   ],
        [ BriefingBlockTypeEnum.THREE_COLUMN_LAYOUT,    briefingThreeColumnLayoutBlockType ],
        [ BriefingBlockTypeEnum.ANALYSIS,               briefingAnalysisBlockType          ],
        [ BriefingBlockTypeEnum.DIVIDER,                briefingDividerBlockType           ],
        [ BriefingBlockTypeEnum.LINK,                   briefingLinkBlockType              ],
        [ BriefingBlockTypeEnum.CHART,                  briefingChartBlockType             ],
        [ BriefingBlockTypeEnum.COVERAGE_CURATOR,       briefingCuratorBlockType           ],
    ]
);


export const briefingsDefaultBlockTypes: BlockTypeModel[] = [
    titleBlockType,
    briefingTextBlockType,
    briefingImageBlockType,
    dateBlockType,
    briefingChartBlockType,
    briefingLinkBlockType,
    briefingAnalysisBlockType,
    briefingCuratorBlockType,
];

export const briefingsSubBlockTypes: BlockTypeModel[] = [
    tableOfContentBlockType,
    briefingDividerBlockType,
];

export const briefingsMentionListBlockTypes: BlockTypeModel[] = [
    curatedMentionListBlockType,
    dynamicMentionListBlockType
];

export const briefingLayoutBlockTypes: BlockTypeModel[] = [
    briefingOneColumnLayoutBlockType,
    briefingTwoColumnLayoutBlockType,
    briefingThreeColumnLayoutBlockType
];

export const briefingsBlockTypes: BlockTypeModel[] = [
    ...briefingsDefaultBlockTypes,
    ...briefingsMentionListBlockTypes,
    ...briefingLayoutBlockTypes
];
